module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-trigger",
    staticStyle: {
      "height": "0",
      "width": "100%",
      "position": "absolute",
      "bottom": "0",
      "left": "0"
    }
  }, [_c('div', {
    directives: [{
      name: "waypoint",
      rawName: "v-waypoint",
      value: ({
        active: true,
        callback: _vm.onWaypoint,
        options: _vm.intersectionOptions
      }),
      expression: "{ active: true, callback: onWaypoint, options: intersectionOptions }"
    }],
    staticClass: "block-trigger__waypoint",
    staticStyle: {
      "height": "1px"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6de0b56d","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/block/block-trigger/block-trigger.pug
// module id = 653
// module chunks = 1